const routeTypeConstant = {
  DPC: 'DPC',
  ADVOCATE: 'ADVOCATE',
  MULTIPLE_LOCATION: 'MULTIPLE_LOCATION'
}

export default routeTypeConstant;